// tirando processamento do back
const moment = require("moment");

const LOW_BATTERY = 11.8;

// Espelha sir-prod/src/actuator/Queries.js::VOLUME_ANOMALY_THRESHOLD. null = guarda desligada
// (comportamento atual, sem teto). Setar um valor pra ativar o filtro de anomalia.
const VOLUME_ANOMALY_THRESHOLD = null;

function getTimestamp(datetime) {
  let dt = datetime.replace(/ /g, "T");
  return Math.round(new Date(dt).getTime());
}

function organizeLogToColumns(logs) {
  return new Promise(resolve => {
    if (!logs.length) resolve([]);
    let result = [];
    let formatting = "YYYY-MM-DD HH:mm:ss";
    for (let i = 1; i < logs.length; i++) {
      let log = logs[i];
      let currentlyTime = moment(log.TIME).format(formatting);
      let currently = log.VALUE;
      let prevValue = logs[i - 1].VALUE;
      // let difference = prevValue - currently ;
      let difference = prevValue - currently;
      if (difference >= 0) {
        result.push({
          TIME: currentlyTime,
          VALUE: difference
        });
      }
    }
    resolve(result);
  });
}

function organizeLogToColumnsWithSameDate(logs) {
  return new Promise(resolve => {
    if (!logs.length) resolve([]);
    let result = [];
    let formatting = "YYYY-MM-DD HH:mm:ss";
    for (let i = 1; i < logs.length; i++) {
      let log = logs[i];
      let currentlyTime = moment(log.TIME).format(formatting);
      let maxValue = log.MAX_VALUE;
      let logValue = log.VALUE;
      let minutes = 0;
      if (logValue > maxValue) {
        minutes += 5;
      }

      if (logValue >= 0) {
        result.push({
          TIME: currentlyTime,
          VALUE: minutes // Minutos acima do máximo
        });
      }
    }

    resolve(result);
  });
}

function organizeValveLogToColumns(logs) {
  return new Promise(resolve => {
    if (!logs.length) resolve([]);
    let result = [];
    let reference = null;
    let formatting = "YYYY-MM-DD HH:mm:ss";
    let counter = 0;
    for (let i = 0; i < logs.length; i++) {
      let log = logs[i];
      if (log.OPEN === 1) {
        let difference = log.VOL_VALUE - reference;
        let withinThreshold =
          VOLUME_ANOMALY_THRESHOLD === null || difference <= VOLUME_ANOMALY_THRESHOLD;
        if (reference !== null && difference > 0 && withinThreshold) {
          result.push({
            TIME: moment(log.TIME).format(formatting),
            VALUE: difference
          });
        }
        reference = log.VOL_VALUE;
      } else {
        reference = null;
      }
      counter++;
      if (counter == logs.length) resolve(result);
    }
  });
}

function organizeColumnLogsPerDay(list) {
  return new Promise(resolve => {
    if (!list.length) resolve([]);
    let result = [];
    let days = list
      .map(e => e.TIME.split(" ")[0])
      .filter((e, i, arr) => arr.indexOf(e) == i);
    for (let i = 0; i < days.length; i++) {
      let day = days[i];
      result.push({
        TIME: day + " 00:00:00",
        VALUE: list
          .filter(e => {
            return e.TIME.split(" ")[0] == day;
          })
          .reduce((acc, e) => acc + e.VALUE, 0)
      });
      if (result.length == days.length) {
        resolve(
          result.sort((a, b) => {
            if (a.TIME > b.TIME) return 1;
            else if (a.TIME < b.TIME) return -1;
            return 0;
          })
        );
      }
    }
  });
}
function organizeLogsForCharts(logs) {
  let result = [];
  for (let log of logs) {
    if (log.length) {
      let data = log.map(e => [
        getTimestamp(e.TIME),
        (e.VALUE / 60).toFixed(2)
      ]);
      result.push(data);
    } else {
      result.push([]);
    }
  }
  return result;
}

function calcOutOfRangeDurationPerDay(logs) {
  if (!logs.length) return [];

  const sortedLogs = [...logs].sort((a, b) =>
    moment(a.TIME).valueOf() - moment(b.TIME).valueOf()
  );

  const days = [...new Set(sortedLogs.map(e => e.TIME.split(" ")[0]))];

  const result = [];

  for (const medType of ["min", "max"]) {
    const durationPerDay = new Map(days.map(day => [day, 0]));

    for (let i = 0; i < sortedLogs.length - 1; i++) {
      const current = sortedLogs[i];
      const next = sortedLogs[i + 1];

      const isOutOfRange =
        medType === "max"
          ? current.VALUE > current.MAX_VALUE
          : current.VALUE < current.MIN_VALUE;

      if (!isOutOfRange) continue;

      const currentDay = current.TIME.split(" ")[0];
      const nextDay = next.TIME.split(" ")[0];

      if (currentDay === nextDay) {
        const duration = Math.abs(
          moment(next.TIME).diff(moment(current.TIME), "minutes", true)
        );
        if (duration > 0) {
          durationPerDay.set(currentDay, durationPerDay.get(currentDay) + duration);
        }
      } else {
        // Do log atual até a meia-noite do dia atual
        const endOfCurrentDay = moment(currentDay).endOf("day");
        const durationInCurrentDay = Math.abs(
          endOfCurrentDay.diff(moment(current.TIME), "minutes", true)
        );
        if (durationInCurrentDay > 0) {
          durationPerDay.set(currentDay, durationPerDay.get(currentDay) + durationInCurrentDay);
        }

        // Da meia-noite do próximo dia até o próximo log
        const startOfNextDay = moment(nextDay).startOf("day");
        const durationInNextDay = Math.abs(
          moment(next.TIME).diff(startOfNextDay, "minutes", true)
        );
        if (durationInNextDay > 0) {
          durationPerDay.set(nextDay, durationPerDay.get(nextDay) + durationInNextDay);
        }
      }
    }


    const data = [...durationPerDay.entries()].map(([day, totalMinutes]) => ({
      TIME: `${day} 00:00:00`,
      VALUE: totalMinutes,
      POS: logs[0].POS,
      UNIT: logs[0].UNIT
    }));

    result.push(data);
  }

  return result;
}

async function organizeLogMaxMin(info, name, MEASURES) {
  const logs = Array.isArray(info.value[1]) ? info.value[0] : info.value;

  const units = new Set(MEASURES.map(e => e.UNIT))

  const measuresPerUnit = {};

  for (const unit of units.values()) {
    const measurements = MEASURES.filter(e => e.UNIT == unit)

    measuresPerUnit[unit] = measurements

    for (const measurementIndex in measurements) {
      const measurement = measurements[measurementIndex]

      const data = logs.filter(
        log =>
          log.TYPE == measurement.TYPE &&
          log.UNIT == measurement.UNIT &&
          log.POS == measurement.POS
      );

      const outOfRangeDurationPerDay = calcOutOfRangeDurationPerDay(data);
      const outOfRangeDurationPerHour = organizeLogsForCharts(outOfRangeDurationPerDay)

      measuresPerUnit[unit][measurementIndex] = {
        type: "bar",
        pos: measurement.POS,
        measure: measurement.TYPE,
        unit: measurement.UNIT,
        max: measurement.RANGE.MAX || 1000000,
        min: measurement.RANGE.MIN || -1000000,
        data: outOfRangeDurationPerHour
      };
    }

  }

  return {
    value: {
      name,
      type: null,
      info,
      measuresPerUnit
    }
  }
}

function calcAccumulatedDiff(logs) {
  return logs
    .sort((a, b) => new Date(a.TIME) - new Date(b.TIME))
    .map((e, i, arr) => {
      const prev = arr[i - 1];
      let diff;

      if (!prev) {
        diff = 0;
      } else if (e.VALUE < prev.VALUE) {
        diff = e.VALUE;
      } else {
        diff = e.VALUE - prev.VALUE;
      }

      return { ...e, VALUE: Number(diff).toFixed(2) };
    });
}
// apex below
function organizeLog(info, EQP, name, MEASURES, to, area) {
  return new Promise((resolve, reject) => {
    let logs = [];
    logs = Array.isArray(info.value[1]) ? info.value[0] : info.value;

    let obj = {
      name,
      type: "area",
      info
    };
    if (EQP == "STATION") {
      // Sem leituras não há como montar as medidas do gráfico; sinaliza "sem dados"
      // em vez de resolver com sucesso e deixar o consumidor acessar chaves ausentes.
      if (!logs.length) {
        return resolve({
          status: 0,
          failed: 0,
          alert: "w",
          log: "Não há dados de estação para exibir no período."
        });
      }
      //dividir logs por medidas
      //agrupar tudo em um objeto para fazer o gráfico
      let name = obj.name[0]; //apenas um sensor EMR por estação
      let typesPerSensor = logs
        .map(e => e.TYPE)
        .filter((e, i, arr) => arr.indexOf(e) == i);

      obj.typesPerSns = typesPerSensor;
      typesPerSensor.map(type => {
        let log = logs.filter(
          data => data.TYPE == type
          // && data.NAME == name
        )[0];

        if (type === "P.M.F.") {
          organizeLogToColumnsWithSameDate(
            logs.filter(e => e.TYPE == log.TYPE && e.UNIT == log.UNIT)
          )
            .then(ret => {
              return organizeColumnLogsPerDay(ret);
            })
            .then(ret => {
              ret.map(item => {
                const hours = item.VALUE / 60;
                item.VALUE = hours.toFixed(2);
              });

              obj["P.M.F."] = {
                measure: "MOLHAMENTO FOLIAR",
                unit: log.UNIT,
                max: log.MAX_VALUE || 1000000,
                min: log.MIN_VALUE || -1000000,
                data: ret.length
                  ? ret.map(e => [getTimestamp(e.TIME), e.VALUE])
                  : []
              };
            });
        } else {
          obj[type] = {
            measure: log.TYPE,
            unit: log.UNIT,
            max: (log.RANGE && log.RANGE.MAX) || 1000000,
            min: (log.RANGE && log.RANGE.MIN) || -1000000,
            data: logs
              .filter(e => e.TYPE == log.TYPE && e.UNIT == log.UNIT)
              // && e.NAME == log.NAME
              .map(e => [getTimestamp(e.TIME), e.VALUE.toFixed(4)])
          };

        }

        if (type == "ALTURA PLUVIOMÉTRICA") {
          organizeLogToColumns(
            logs.filter(e => e.TYPE == log.TYPE && e.UNIT == log.UNIT)
          )
            .then(ret => organizeColumnLogsPerDay(ret))
            .then(ret => {
              obj["ALTURA PLUVIOMÉTRICA DIÁRIA"] = {
                measure: "ALTURA PLUVIOMÉTRICA DIÁRIA",
                unit: log.UNIT,
                max: (log.RANGE && log.RANGE.MAX) || 1000000,
                min: (log.RANGE && log.RANGE.MIN) || -1000000,
                data: ret.length
                  ? ret.map(e => [getTimestamp(e.TIME), e.VALUE.toFixed(4)])
                  : []
              };
            });
        }
      }); // typesPerSensor.map
      resolve({
        status: 1,
        failed: 0,
        alert: "s",
        log: "Sucesso na geração do gráfico de medição de sensor.",
        value: obj
        /* obj = Objeto = {
          name: Array = [nomeSns1, nomeSns2],
          typesPerSns = Array de Arrays = [[med1Sns1, med2Sns1], [med1Sns2, med2Sns2]]
          sns1: Objeto = {
            med1: Array = [logs],
            med2: Array = [logs]
          }
          ...
        } */
      });
    } else if (EQP == "SENSOR") {
      if (!logs.length && to == "chartsPage") {
        return resolve({
          status: 0,
          failed: 0,
          alert: "w",
          log: "Erro na identificação do tipo de equipamento do gráfico."
        });
      }

      let counter = 0;

      let columnChart = [
        "VOLUME",
        "ALTURA PLUVIOMÉTRICA",
        "ENERGIA ATIVA",
        "ENERGIA REATIVA",
      ];



      // Página de gráfico de equipamentos
      if (to == "chartsPage") {
        obj.type = "line";
        for (let i = 0; i < MEASURES.length; i++) {
          let col = MEASURES[i];

          // Alguns sensores (ex: PIR) devolvem TYPE em capitalização diferente
          // da usada no cadastro de MEASURES (ex: "PRESSÃO" vs "Pressão") —
          // comparação case-insensitive evita que a série fique vazia por causa disso.
          const colType = (col.TYPE || "").toUpperCase();
          const filteredLogs = logs
            .filter((e) => (e.TYPE || "").toUpperCase() === colType && e.UNIT == col.UNIT)

          if (col.PER_READING) {
            let data = filteredLogs

            if (col.TYPE === "ALTURA PLUVIOMÉTRICA") {
              data = calcAccumulatedDiff(filteredLogs);
            }

            obj[col.TYPE] = {
              type: "line",
              measure: col.TYPE,
              unit: col.UNIT,
              max: (col.RANGE && col.RANGE.MAX) || 1000000,
              min: (col.RANGE && col.RANGE.MIN) || -1000000,
              data: data.map((e) => [getTimestamp(e.TIME), e.VALUE])
            };

            if (++counter === MEASURES.length) {
              resolve({
                status: 1, failed: 0, alert: "s",
                log: "Sucesso na geração do gráfico por leitura.",
                value: obj,
              });
            }

            continue;
          }

          if (columnChart.includes(col.TYPE)) {
            organizeLogToColumns(
              filteredLogs
            )
              .then(ret => organizeColumnLogsPerDay(ret))
              .then(ret => {
                obj[col.TYPE] = {
                  type: "bar",
                  measure: col.TYPE,
                  unit: col.UNIT,
                  max: (col.RANGE && col.RANGE.MAX) || 1000000,
                  min: (col.RANGE && col.RANGE.MIN) || -1000000,
                  data: ret.length
                    ? ret.map(e => [getTimestamp(e.TIME), e.VALUE.toFixed(2)])
                    : []
                };
                return;
              })
              .then(_ => {
                counter++;
                if (counter == MEASURES.length) {
                  resolve({
                    status: 1,
                    failed: 0,
                    alert: "s",
                    log: "Sucesso na geração do gráfico de medição de sensor.",
                    value: obj
                  });
                }
              });
          } else {
            obj[col.TYPE] = {
              measure: col.TYPE,
              unit: col.UNIT,
              max: (col.RANGE && col.RANGE.MAX) || 1000000,
              min: (col.RANGE && col.RANGE.MIN) || -1000000,
              data: filteredLogs
                .map(e => [getTimestamp(e.TIME), e.VALUE.toFixed(2)])
            };
            // counter++;
            if (++counter == MEASURES.length) {
              resolve({
                status: 1,
                failed: 0,
                alert: "s",
                log: "Sucesso na geração do gráfico de medição de sensor.",
                value: obj
              });
            }
          }
        }
      }
      //Se escolher qual medição específica irá gerar o gráfico
      else if (to == "unit_measure") {
        let units = MEASURES.map(e => e.UNIT).filter(
          (e, i, arr) => arr.indexOf(e) == i
        );
        let measuresPerUnit = {};
        units.forEach(
          unit => (measuresPerUnit[unit] = MEASURES.filter(e => e.UNIT == unit))
        );
        units.forEach(unit => {
          measuresPerUnit[unit].forEach(async (measure, i) => {
            try {
              let data = logs.filter(
                log =>
                  log.TYPE == measure.TYPE &&
                  log.UNIT == measure.UNIT &&
                  log.POS == measure.POS
              );
              if (columnChart.includes(measure.TYPE)) {
                data = await organizeLogToColumns(data).then(ret =>
                  organizeColumnLogsPerDay(ret)
                );
              }
              measuresPerUnit[unit][i] = {
                type: columnChart.includes(measure.TYPE) ? "bar" : "area",
                pos: measure.POS,
                measure: measure.TYPE,
                unit: measure.UNIT,
                max: (measure.RANGE && measure.RANGE.MAX) || 1000000,
                min: (measure.RANGE && measure.RANGE.MIN) || -1000000,
                data: data.length
                  ? data.map(e => [getTimestamp(e.TIME), e.VALUE.toFixed(2)])
                  : []
              };
              counter++;
              if (counter == MEASURES.length) {
                obj.measuresPerUnit = measuresPerUnit;
                resolve({
                  value: {
                    name,
                    type: null,
                    info,
                    measuresPerUnit
                  }
                });
              }
            } catch (e) {
              console.log(e);
            }
          });
        });
      } else {
        console.log({ info, EQP, name, MEASURES, to, area });
        // !to == 'monitSensor'
        let units = MEASURES.map(e => e.UNIT).filter(
          (e, i, arr) => arr.indexOf(e) == i
        );
        let measuresPerUnit = {};
        units.forEach(
          unit => (measuresPerUnit[unit] = MEASURES.filter(e => e.UNIT == unit))
        );
        units.forEach(unit => {
          measuresPerUnit[unit].forEach(async (measure, i) => {
            try {
              let data = logs.filter(
                log =>
                  log.TYPE == measure.TYPE &&
                  log.UNIT == measure.UNIT &&
                  log.POS == measure.POS
              );
              const isColumnChart = columnChart.includes(measure.TYPE.toUpperCase())
              if (isColumnChart) {
                data = await organizeLogToColumns(data).then(ret =>
                  organizeColumnLogsPerDay(ret)
                );
              }
              measuresPerUnit[unit][i] = {
                type: isColumnChart ? "bar" : "area",
                pos: measure.POS,
                measure: measure.TYPE,
                unit: measure.UNIT,
                max: (measure.RANGE && measure.RANGE.MAX) || 1000000,
                min: (measure.RANGE && measure.RANGE.MIN) || -1000000,
                data: data.length
                  ? data.map(e => [getTimestamp(e.TIME), e.VALUE.toFixed(2)])
                  : []
              };
              counter++;
              if (counter == MEASURES.length) {
                obj.measuresPerUnit = measuresPerUnit;
                resolve({
                  status: 1,
                  failed: 0,
                  alert: "s",
                  log: "Sucesso na geração do gráfico de medição de sensor.",
                  value: {
                    name,
                    type: null,
                    info,
                    measuresPerUnit
                  }
                });
              }
            } catch (e) {
              console.error(e);
            }
          });
        });
      }
    } else if (EQP == "DIR" || EQP == "MTD") {
      if (!logs.length && to == "chartsPage") {
        return resolve({
          status: 0,
          failed: 0,
          alert: "w",
          log: "Erro na identificação do tipo de equipamento do gráfico."
        });
      }
      // let xAxes = logs.map(e => getTimestamp(e.TIME));
      // obj.xAxes = xAxes;
      obj.BAT = {
        measure: "BATERIA",
        unit: "V",
        max: 1000000,
        min: LOW_BATTERY,
        data: logs.map(e => [getTimestamp(e.TIME), e.BAT_VALUE.toFixed(2)])
      };
      obj.ACK = {
        measure: "SINAL",
        unit: "%",
        max: 1000000,
        min: -1000000,
        data: logs.map(e => [getTimestamp(e.TIME), e.ACK_VALUE * 2])
      };
      resolve({
        status: 1,
        failed: 0,
        alert: "s",
        log: "Sucesso na geração do gráfico de DIR.",
        value: obj
      });
    } else if (EQP == "ACTUATOR") {
      // Sem essa guarda, `logs` vazio (nenhum registro no período) faz `logs[0].ID`
      // estourar mais abaixo dentro de uma cadeia de .then() que não está ligada
      // ao resolve/reject desta Promise — o erro não propaga e a chamada nunca
      // resolve nem rejeita, travando o "Carregando..." pra sempre no chamador.
      // Os dois chamadores atuais (ActuatorCharts, PivotSensorChart) sempre passam
      // to=null, então a guarda original (`to == "chartsPage"`) nunca disparava.
      if (!logs.length) {
        return resolve({
          status: 0,
          failed: 0,
          alert: "w",
          log: "Não há dados de atuação no período."
        });
      }
      logs.sort(function (a, b) {
        var c = new Date(a.TIME);
        var d = new Date(b.TIME);
        return c - d;
      });
      return Promise.resolve(
        logs.map(log => {
          if (log.OPEN !== 1) {
            // log.VOL_VALUE = 0;
            log.FLOW_VALUE = 0;
          }
          return log;
        })
      )
        .then(logsCorrected => {
          logs = logsCorrected;
          return organizeValveLogToColumns(logs);
        })
        .then(ret => {
          return organizeColumnLogsPerDay(ret);
        })
        .then(ret => {
          // obj.xAxes = ret.xAxes;
          let isValve = logs[0].ID >= 1000000;
          let hectare = 10000;
          let regexFIR = /FIR/g;
          obj.DEPTH = {
            type: "bar",
            measure: "LÂMINA",
            unit: "mm",
            max: 1000000,
            min: -1000000,
            data: ret.map(e => [
              getTimestamp(e.TIME),
              area
                ? ((e.VALUE / (area * hectare)) * 1000).toFixed(2) //cálculo da lâmina diária
                : "0.00",
              e.NOTE ? e.NOTE : "---"
            ])
          };
          obj.FLOW = {
            measure: "VAZÃO",
            unit: "m³/h",
            max: isValve ? logs[0].MAX_FLOW : 1000000,
            min: isValve ? logs[0].MIN_FLOW : -1000000,
            data: logs.map(e => [getTimestamp(e.TIME), e.FLOW_VALUE.toFixed(2)])
          };
          obj.VOL = {
            type: "bar",
            measure: "VOLUME",
            unit: name.match(regexFIR) ? "L" : "m³",
            max: 1000000,
            min: -1000000,
            data: ret.map(e => {
              return [getTimestamp(e.TIME), e.VALUE.toFixed(2)];
            })
          };
          obj.OPEN = {
            measure: "ATUAÇÃO",
            curve: "stepline",
            unit: "",
            max: 1000000,
            min: -1000000,
            data: logs.map(e => [getTimestamp(e.TIME), e.OPEN])
          };
          resolve({
            status: 1,
            failed: 0,
            alert: "s",
            log: "Sucesso na geração do gráfico de válvula.",
            value: obj
          });
        });
    } else {
      reject({
        status: 0,
        failed: 1,
        alert: "w",
        log: "Erro na identificação do tipo de equipamento do gráfico."
      });
    }
  });
}

export { organizeLog, organizeLogMaxMin };
